import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Video, VideoRecord } from '../../types';
import VideoModal from './VideoModal';

interface VideoListProps {
    videos: Video[];
    onSetMaster: (record: VideoRecord, videoId: number) => void;
    record: VideoRecord;
    onUrlsRefreshed?: () => void
}

const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const VideoList: React.FC<VideoListProps> = ({ videos, onSetMaster, record }) => {
    const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
    const [showModal, setShowModal] = useState(false);

    const handleViewVideo = async (video: Video) => {
        setSelectedVideo(video);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <Accordion className="mt-4" >
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        Videos
                        {videos.length > 0 && (
                            <Badge bg="info" className="ms-2">
                                {videos.length}
                            </Badge>
                        )}
                    </Accordion.Header>

                    <Accordion.Body>
                        <Row xs={1} md={2} className="g-3 videos-container">

                            {videos.map(video => (
                                <Col key={video.id}>
                                    <Card border={video.is_master ? 'primary' : ''}>
                                        <Card.Header>
                                            <h6 className="mb-0 text-truncate" style={{ fontSize: '0.9rem' }}>{video.title}</h6>
                                            <small className="text-muted">{video.camera}</small>
                                        </Card.Header>
                                        <Card.Body className="p-2">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center">
                                                    <Form.Check
                                                        type="radio"
                                                        id={`video_${video.id}`}
                                                        name={`masterVideo_${record.id}`}
                                                        checked={video.is_master}
                                                        onChange={() => onSetMaster(record, video.id)}
                                                        className="me-2 mb-0"
                                                    />
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    {video.is_master && <Badge bg="primary" className="me-1">Master</Badge>}
                                                    <Badge
                                                        bg={video.type === 'PANORAMA' ? 'success' : 'info'}
                                                        className="me-1"
                                                    >
                                                        {video.type}
                                                    </Badge>
                                                    <Badge bg="dark">{formatFileSize(video.size)}</Badge>
                                                </div>
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="me-1"
                                                    onClick={() => handleViewVideo(video)}
                                                >
                                                    View
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}

                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>



            {/* Video Modal */}
            <VideoModal
                show={showModal}
                onHide={handleCloseModal}
                video={selectedVideo}
            />
        </>
    );
};

export default VideoList;
